
import { IGeoLocation } from './hotels';

export enum CondoMatchTypeEnum {
  Alternative = 'Alternative',
  Exact = 'Exact',
}

export interface IBounds {
  southWest: IGeoLocation;
  northEast: IGeoLocation;
}

export interface IBounds {
  southWest: IGeoLocation;
  northEast: IGeoLocation;
}

export enum DateSearchTypeEnum {
  Strict = 'Strict',
  Flexible = 'Flexible',
  Anytime = 'Anytime',
}
